import { recordArtifactFulfilled } from '@streem/analytics';
import { WallItem } from 'streem-sdk-protobuf';
import { shareReplay } from 'rxjs';
import { logger } from '../../util/logger';
import { accumulateAndMapWallEvents, filterByProperty, findInGroup } from '../wall/utils';
import { lastCreatedAt } from '../../util/rx/last_created_at';
export class PersonalizationController {
    constructor(config) {
        this.config = config;
        const localUserId = config.context.localUserId;
        if (!localUserId) {
            logger.debug('Loaded PersonalizationController without a localUserId: personalizations will be disabled');
        }
        this.roomOutcomeReport = this.config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndMapWallEvents('artifact'), filterByProperty('artifactType', WallItem.ArtifactType.ROOM_OUTCOME_REPORT), lastCreatedAt(), shareReplay(1));
    }
    addRoomOutcomeReport(roomOutcomeReport) {
        const response = this.config.roomWall.addRoomOutcomeReport({
            artifactType: WallItem.ArtifactType.ROOM_OUTCOME_REPORT,
            roomOutcomeReport: roomOutcomeReport,
            status: WallItem.Artifact.Status.FULFILLED,
        });
        recordArtifactFulfilled(response);
        logger.info(`added room outcome report to wall:`, response);
    }
}
//# sourceMappingURL=personalization_controller.js.map